/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export const LANGUAGES = [
    {
        label: 'English',
        value: 'en_US',
    },
    {
        label: '日本語',
        value: 'ja',
    },
];
